// Product card quick-add: normalises every card's button across the site.
//
// 1. Relocation: stock Horizon renders the button inside .card-gallery (an
//    overflow:hidden image container we can't edit), absolutely positioned
//    as a photo overlay. We move it to be the last child of
//    .product-card__content so it renders in normal flow below the size
//    line. A MutationObserver (not just a load-time pass) covers cards the
//    carousel renders or duplicates after the initial page load.
//
// 2. Width: for a single-variant product, the button sits inside an extra
//    <add-to-cart-component> wrapper that isn't present for a multi-variant
//    "Choose" button; that wrapper shrink-wraps to the button's natural
//    content width, so a plain `width:100%` on the button alone still
//    renders ~94px wide. We walk every ancestor between the button and
//    .quick-add and force each one to block/100% width, so the chain can't
//    collapse regardless of which wrapper elements are present.
//
// 3. Label: Shopify's own compact label is just "Add" or "Choose". We
//    replace it with "Add to cart" (single variant), "Select size"
//    (multi-variant, first option named Size), or "Choose options"
//    (multi-variant, any other first option name).
//
// 4. Badge: a card's custom-liquid block renders a hidden .gsb-badge-data
//    marker with the badge text (e.g. Best Seller), computed server-side
//    from collection membership. We build the real .pc-badge pill and move
//    it into .card-gallery, the only element it can visually overlay.
//
// 5. Recommendation rows only: Bio-G Pro is discontinued and must never
//    appear as a recommendation, but must still show normally on collection
//    pages and in search. Its card carries a hidden .gsb-exclude marker
//    (set only in the recommendations template, not on Home or collection
//    grids). The recommendations section requests 5 products instead of 4
//    so excluding one still leaves a full row; we remove excluded and any
//    excess .resource-list__item wrappers entirely, rather than hiding
//    them, because Horizon's own responsive column CSS counts ALL DOM
//    children via nth-last-child regardless of visibility, so a
//    display:none item would still throw off that count.
(function () {
  function widenChain(button, boundary) {
    var el = button.parentElement;
    while (el && el !== boundary) {
      el.style.display = 'block';
      el.style.width = '100%';
      el = el.parentElement;
    }
  }

  function labelFor(card) {
    var qa = card.querySelector('quick-add-component, add-to-cart-component');
    var mode = qa ? qa.getAttribute('data-quick-add-button') : null;
    if (mode === 'choose') {
      var marker = card.querySelector('[data-gsb-option1]');
      var option1 = marker ? marker.getAttribute('data-gsb-option1') : '';
      return option1.toLowerCase() === 'size' ? 'Select size' : 'Choose options';
    }
    return 'Add to cart';
  }

  function setLabel(button, label) {
    var replaced = false;
    Array.from(button.childNodes).forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        node.textContent = ' ' + label + ' ';
        replaced = true;
      }
    });
    if (!replaced) {
      button.appendChild(document.createTextNode(' ' + label + ' '));
    }
    button.setAttribute('aria-label', label);
  }

  function relocateBadge(card) {
    var marker = card.querySelector('.gsb-badge-data');
    var gallery = card.querySelector('.card-gallery');
    if (!marker || !gallery || marker.getAttribute('data-gsb-placed') === 'true') return;

    var label = marker.getAttribute('data-label');
    marker.setAttribute('data-gsb-placed', 'true');
    if (!label) return;

    var badge = document.createElement('span');
    badge.className = 'pc-badge';
    badge.textContent = label;
    gallery.insertBefore(badge, gallery.firstChild);
  }

  function relocate(card) {
    relocateBadge(card);

    var content = card.querySelector('.product-card__content');
    var quickAdd = card.querySelector('.quick-add');
    if (!content || !quickAdd) return;
    if (quickAdd.parentElement !== content) {
      content.appendChild(quickAdd);
    }

    var btn = quickAdd.querySelector('.quick-add__button');
    if (!btn || btn.getAttribute('data-gsb-labelled') === 'true') return;

    widenChain(btn, quickAdd);
    setLabel(btn, labelFor(card));
    btn.setAttribute('data-gsb-labelled', 'true');
  }

  function relocateAll() {
    document.querySelectorAll('.product-card').forEach(relocate);
  }

  function capRecommendations() {
    var grid = document.querySelector('product-recommendations .resource-list--grid');
    if (!grid) return;

    var max = 4;
    var kept = 0;
    Array.prototype.forEach.call(grid.children, function (item) {
      if (!item.classList.contains('resource-list__item')) return;
      if (item.querySelector('.gsb-exclude')) {
        item.remove();
        return;
      }
      kept++;
      if (kept > max) item.remove();
    });
  }

  function runAll() {
    capRecommendations();
    relocateAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }

  document.addEventListener('shopify:section:load', runAll);

  var observer = new MutationObserver(function (mutations) {
    var shouldRun = false;
    for (var i = 0; i < mutations.length && !shouldRun; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType === 1 && (node.matches('.product-card') || node.querySelector('.product-card'))) {
          shouldRun = true;
          break;
        }
      }
    }
    if (shouldRun) runAll();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
